import React from "react"

import Index from "../components/pages/summary2022.js"

const IndexPage = () => (
  <Index lang="pl" />
)

export default IndexPage